export default class ScholarshipsDiscountsDataStoreMock {
  getScholarshipsDiscounts() {
    return Promise.resolve([]);
  }

  getAgreementInfo(codigoTramite: number) {
    return Promise.resolve({ codigoTramite });
  }

  registerAgreement(input: any) {
    return Promise.resolve({
      id: 1,
      state: 'registered',
      message: `Agreement registered successfully${input}`
    });
  }
}
